<template>
  <div>
    <section
      class="box-detail form-detail"
      v-if="
        dataContract.groupService !== 'SELL' &&
        dataContract.lstAppendixTrans &&
        dataContract.lstAppendixTrans.length > 0
      "
    >
      <h1>Phụ lục phí giao dịch</h1>
      <div class="table-responsive">
        <table class="table table-hover table-bordered">
          <thead class="thead-light">
            <tr>
              <th scope="col" class="text-left">Số phụ lục</th>
              <th scope="col" class="text-left">Thời gian</th>
              <th scope="col" class="text-left">Trạng thái</th>
              <th scope="col" class="text-left">Chi tiết</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in dataContract.lstAppendixTrans" :key="index">
            <tr class="table-row">
              <td align="left">{{ item.code }}</td>
              <td align="left">
                <p v-if="item.dateCreatedAppendixDTO || item.dateCreate">
                  <b>Ngày tạo :</b>
                  {{
                    item.dateCreatedAppendixDTO
                      ? item.dateCreatedAppendixDTO
                      : item.dateCreate | formatDate('HH:mm DD/MM/YYYY')
                  }}
                </p>
                <p
                  v-if="
                    item.state &&
                    (item.state === 'SIGNED_WAITING_APPROVED' ||
                      item.state === 'APPROVED' ||
                      item.state === 'REJECTED_SA') &&
                    (item.dateSignAppendixDTO || item.dateSign)
                  "
                >
                  <b>Ngày ký :</b>
                  {{
                    item.dateSignAppendixDTO ? item.dateSignAppendixDTO : item.dateSign | formatDate
                  }}
                </p>
                <p v-if="item.state && item.state === 'CANCELED' && item.dateCancelDTO">
                  <b>Ngày huỷ :</b> {{ item.dateCancelDTO | formatDate }}
                </p>
              </td>
              <td align="left">
                <span class="badge" v-bind:class="[item.state ? item.state : '']">{{
                  item.state ? item.state : '' | mapTextStatus(listStatusContract)
                }}</span>
              </td>
              <td align="left">
                <span
                  @click="showFeeModal(item.appendixFeeTrans.feeCardAndPayment)"
                  v-if="item.isDefaultFee"
                  ><span class="text-info">Xem phí mặc định</span></span
                >
                <span
                  @click="showFeeModal(item.appendixFeeTrans.feeCardAndPayment)"
                  v-if="!item.isDefaultFee"
                  ><span class="text-info">Xem phí đề xuất</span></span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <div
      class="form-detail"
      v-if="dataContract.lstAppendixAuthBanks && dataContract.lstAppendixAuthBanks.length > 0"
    >
      <h1>Phụ lục ủy quyền ngân hàng</h1>
      <div class="table-responsive">
        <table class="table table-hover table-bordered">
          <thead class="thead-light">
            <tr>
              <th scope="col" class="text-left">Số phụ lục</th>
              <th scope="col" class="text-left">Thời gian</th>
              <th scope="col" class="text-left">Trạng thái</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in dataContract.lstAppendixAuthBanks" :key="index">
            <tr class="table-row">
              <td align="left">{{ item.code }}</td>
              <td align="left">
                <p v-if="item.dateCreatedAppendixDTO || item.dateCreate">
                  <b>Ngày tạo :</b>
                  {{
                    item.dateCreatedAppendixDTO
                      ? item.dateCreatedAppendixDTO
                      : item.dateCreate | formatDate('HH:mm DD/MM/YYYY')
                  }}
                </p>
                <p
                  v-if="
                    item.state &&
                    (item.state === 'SIGNED_WAITING_APPROVED' ||
                      item.state === 'APPROVED' ||
                      item.state === 'REJECTED_SA') &&
                    (item.dateSignAppendixDTO || item.dateSign)
                  "
                >
                  <b>Ngày ký :</b>
                  {{
                    item.dateSignAppendixDTO ? item.dateSignAppendixDTO : item.dateSign | formatDate
                  }}
                </p>
                <p v-if="item.state && item.state === 'CANCELED' && item.dateCancelDTO">
                  <b>Ngày huỷ :</b> {{ item.dateCancelDTO | formatDate }}
                </p>
              </td>
              <td align="left">
                <span class="badge" v-bind:class="[item.state ? item.state : '']">{{
                  item.state ? item.state : '' | mapTextStatus(listStatusContract)
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="form-detail"
      v-if="
        dataContract.lstAppendixAuthContracts && dataContract.lstAppendixAuthContracts.length > 0
      "
    >
      <h1>Phụ lục ủy quyền ký hợp đồng</h1>
      <div
        class="table-responsive"
        v-for="(item, index) in dataContract.lstAppendixAuthContracts"
        :key="index"
      >
        <div class="table-responsive">
          <table class="table table-hover table-bordered">
            <thead class="thead-light">
              <tr>
                <th scope="col" class="text-left">Số phụ lục</th>
                <th scope="col" class="text-left">Thời gian</th>
                <th scope="col" class="text-left">Trạng thái</th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in dataContract.lstAppendixAuthContracts" :key="index">
              <tr class="table-row">
                <td align="left">{{ item.code }}</td>
                <td align="left">
                  <p v-if="item.dateCreatedAppendixDTO || item.dateCreate">
                    <b>Ngày tạo :</b>
                    {{
                      item.dateCreatedAppendixDTO
                        ? item.dateCreatedAppendixDTO
                        : item.dateCreate | formatDate('HH:mm DD/MM/YYYY')
                    }}
                  </p>
                  <p
                    v-if="
                      item.state &&
                      (item.state === 'SIGNED_WAITING_APPROVED' ||
                        item.state === 'APPROVED' ||
                        item.state === 'REJECTED_SA') &&
                      (item.dateSignAppendixDTO || item.dateSign)
                    "
                  >
                    <b>Ngày ký :</b>
                    {{
                      item.dateSignAppendixDTO
                        ? item.dateSignAppendixDTO
                        : item.dateSign | formatDate
                    }}
                  </p>
                  <p v-if="item.state && item.state === 'CANCELED' && item.dateCancelDTO">
                    <b>Ngày huỷ :</b> {{ item.dateCancelDTO | formatDate }}
                  </p>
                </td>
                <td align="left">
                  <span class="badge" v-bind:class="[item.state ? item.state : '']">{{
                    item.state ? item.state : '' | mapTextStatus(listStatusContract)
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="showFee">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-xl">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Biểu phí thanh toán</h5>
                  <button
                    @click="showFee = false"
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center" style="max-height: 500px; overflow: scroll">
                  <div class="table-price table-responsive text-center">
                    <table class="table table-striped table-bordered f12">
                      <thead>
                        <tr class="bg-head1">
                          <th style="width: 50px"><b>STT</b></th>
                          <th><b>Loại thẻ/Phương thức thanh toán</b></th>
                          <th class="txt-center"><b>Mức phí</b></th>
                        </tr>
                      </thead>
                      <tbody v-for="(item, index) in dataTariff" :key="index">
                        <tr>
                          <td class="txt-center">{{ index + 1 }}</td>
                          <td>{{ item.issuerName }}/{{ item.paymentMethod }}</td>
                          <td class="txt-center">
                            <span v-if="item.isDefaultFee === false" style="background: yellow">
                              <b>{{ item.feePerTransaction }} %</b>
                            </span>
                            <span v-else
                              ><b>{{ item.feePerTransaction }} %</b></span
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p class="f14"><b>Lưu ý: </b></p>
                    <ol class="form-style2 f12 text-left">
                      <li><i>Đơn vị tính là VNĐ và đã bao gồm VAT.</i></li>
                      <li>
                        <i
                          >Biểu phí này căn cứ theo chính sách của Bên A được ban hành tại từng thời
                          điểm.</i
                        >
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  export default {
    props: ['dataContract'],
    data() {
      return {
        listStatusContract: Config.listStatusContract,
        showFee: false,
        dataTariff: [],
      }
    },
    methods: {
      showFeeModal(data) {
        this.showFee = true
        this.dataTariff = data
      },
    },
  }
</script>

<style scoped>
  /*Modal Bieu phi*/
  .modal-dialog {
    max-width: 60%;
    overflow-x: auto;
    margin: 0 auto;
  }
  .modal-body {
    width: 100%;
  }
  @media screen and (max-width: 410px) {
    .modal-dialog {
      margin: 0 7%;
      max-width: 76%;
    }
  }
</style>
